import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, withKeys as _withKeys, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "w-lg-500px p-0 p-md-10" }
const _hoisted_2 = { class: "text-center mb-10" }
const _hoisted_3 = ["src"]
const _hoisted_4 = ["src"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "fw-semobold fs-4" }, " Acceso al sistema ", -1)
const _hoisted_6 = { class: "fv-row mb-10" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fs-6 fw-bold text-dark" }, "Usuario", -1)
const _hoisted_8 = { class: "fv-row mb-10" }
const _hoisted_9 = { class: "d-flex flex-stack mb-2" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bold text-dark fs-6 mb-0" }, "Contraseña", -1)
const _hoisted_11 = { class: "text-center" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Continuar ", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Validando... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_14 = [
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = {
  class: "alert alert-light-info text-gray-600 bg-light mb-0",
  role: "alert"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_form, {
      ref: "ruleFormRef",
      model: _ctx.form,
      rules: _ctx.rules,
      class: "form w-100"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          (_ctx.asideTheme === 'dark')
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: _ctx.themeDarkLogo,
                alt: "FEDUP",
                class: "h-100px mb-4"
              }, null, 8, _hoisted_3))
            : _createCommentVNode("", true),
          (_ctx.asideTheme === 'light')
            ? (_openBlock(), _createElementBlock("img", {
                key: 1,
                src: _ctx.themeLightLogo,
                alt: "FEDUP",
                class: "h-100px mb-4"
              }, null, 8, _hoisted_4))
            : _createCommentVNode("", true),
          _hoisted_5
        ]),
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createVNode(_component_el_form_item, { prop: "username" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.form.username,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.username) = $event)),
                "prefix-icon": _ctx.User,
                size: "large",
                placeholder: "Usuario",
                maxlength: "50"
              }, null, 8, ["modelValue", "prefix-icon"])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createVNode(_component_router_link, {
              to: "/password-reset",
              class: "link-primary fs-6 fw-bold d-none"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Recuperar contraseña ? ")
              ]),
              _: 1
            })
          ]),
          _createVNode(_component_el_form_item, { prop: "password" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.form.password,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.password) = $event)),
                "prefix-icon": _ctx.Key,
                onKeypress: _cache[2] || (_cache[2] = _withKeys(($event: any) => (_ctx.onSubmitLogin(_ctx.ruleFormRef)), ["enter"])),
                "show-password": "true",
                size: "large",
                placeholder: "Contraseña",
                maxlength: "30"
              }, null, 8, ["modelValue", "prefix-icon"])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("button", {
            type: "button",
            ref: "submitButton",
            class: "btn btn-lg btn-primary w-100 mb-5",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onSubmitLogin(_ctx.ruleFormRef)))
          }, _hoisted_14, 512),
          _createElementVNode("div", _hoisted_15, [
            _createTextVNode(" Si tuviera algún inconveniente técnico con la plataforma, puede comunicarse al correo: "),
            _createElementVNode("b", null, _toDisplayString(_ctx.emailSupport), 1)
          ])
        ])
      ]),
      _: 1
    }, 8, ["model", "rules"])
  ]))
}